// dependencies
import React from "react";

// styles
import css from "./EmployeeCard.module.scss";

const LoadingEmployeeCard = (className) => (
	<div className={css.employeeContainerSkeleton}>
		<div
			className={`${className} ${css.employeeAvatarContainer} flex flex-col items-center justify-center gap-2 p-4`}
		>
			<div className={css.employeeAvatar} />
		</div>
		<div className={css.employeeName} />
		<div className={css.jobTitle} />
		<div className={css.email} />
		<div className={css.actionButtons}>
			<div />
			<div />
		</div>
	</div>
);

export default LoadingEmployeeCard;
